"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanSanitizer = (value) => {
    return value === 'true' || value === '1';
};
